import { Fragment } from 'react';
import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from '../styles/hero.module.scss';

import type { IHeroContentWrapperProps } from '../types';

const HeroContentWrapper = ({
  embeddedForm,
  children,
}: IHeroContentWrapperProps) => {
  if (embeddedForm === 'none') {
    return <Fragment>{children}</Fragment>;
  }

  return (
    <div className={generateClassName(['hasEmbeddedForm', styles.hasEmbeddedForm])}>
      {children}
    </div>
  );
};

export default HeroContentWrapper;
